<script setup>
import { Button } from '@/components/ui/button';
import { useAppearance } from '@/composables/useAppearance';
import { Monitor, Moon, Sun } from 'lucide-vue-next';
import { computed } from 'vue';

const { appearance, updateAppearance } = useAppearance();

const modes = [
  { value: 'light', Icon: Sun, label: 'Claro' },
  { value: 'dark', Icon: Moon, label: 'Oscuro' },
  { value: 'system', Icon: Monitor, label: 'Sistema' },
];

const currentMode = computed(() => {
  return modes.find((mode) => mode.value === appearance.value) ?? modes[2];
});

const ariaLabel = computed(() => `Tema: ${currentMode.value.label}`);

const cycleAppearance = () => {
  const currentIndex = modes.findIndex((mode) => mode.value === appearance.value);
  const nextIndex = (currentIndex + 1) % modes.length;

  updateAppearance(modes[nextIndex].value);
};
</script>

<template>
  <Button
    type="button"
    variant="ghost"
    size="icon"
    class="cursor-pointer text-muted-foreground hover:text-foreground"
    :aria-label="ariaLabel"
    :title="ariaLabel"
    @click="cycleAppearance"
  >
    <component
      :is="currentMode.Icon"
      class="size-4"
    />
  </Button>
</template>
